export let EducationFunction = /*#__PURE__*/function (EducationFunction) {
  EducationFunction["Teacher"] = "teacher";
  EducationFunction["Manager"] = "manager";
  EducationFunction["Employee"] = "employee";
  EducationFunction["IfapmeAviqTrainer"] = "ifapmeAviqTrainer";
  return EducationFunction;
}({});